import './_left-sidebar.scss'
import {useState} from "react";
import puzzles from "../../../utils/puzzles";
const LeftSidebar = () => {
    const [isCollapsed, setCollapse] = useState(true);

    function setFloor(floor: string) {
        puzzles.callProcedure('setFloor', floor);
    }

    return  <div className={'left-sidebar' + (isCollapsed ? ' collapsed': '')}>
        <div>
            <ul>
                <li id='floor_1'>
                    <span onClick={() => setFloor('floor_1')}>Floor 1</span>
                    <ul>
                        <li>
                            <span>Electrical Cabinet</span>
                        </li>
                    </ul>
                </li>
                <li id='floor_2'>
                    <span onClick={() => setFloor('floor_2')}>Floor 2</span>
                    <ul>
                        <li>
                            <span>Electrical Cabinet</span>
                        </li>
                    </ul>
                </li>
            </ul>

            <button className='expand-btn left-sidebar__btn'
                    onClick={() => setCollapse(false)}
            >
                <img src="./assets/images/arrow.svg" alt="Expand"/>
            </button>
            <button className='collapse-btn left-sidebar__btn'
                    onClick={() => setCollapse(true)}
            >
                <img src="./assets/images/arrow.svg" alt="Collapse"/>
            </button>
        </div>
    </div>
}

export default LeftSidebar;
